import React from 'react'
import LoginApp from '../../features/auth/Login'
export default function Login() {
  return (<LoginApp/> )
}
